export default __webpack_public_path__ + "static/media/05_photo.cc364b8b.jpg";